import { Button, TooltipDesktop } from '@cian/ui-kit';
import { IconFunctionalHide16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { trackHideOffer } from './tracking';
import { useOfferContext } from '../../../../context';
import { ControlWrapper } from 'shared/components/Controls/ControlWrapper';

interface IProps {
  isHovered: boolean;
  onClick: () => void;
}

export const HideFromPrintContainer = ({ isHovered, onClick }: IProps) => {
  const { offer, position } = useOfferContext();

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();

      onClick();
      trackHideOffer(offer.id ?? undefined, position);
    },
    [offer.id, onClick, position],
  );

  return (
    <ControlWrapper visible={isHovered}>
      <TooltipDesktop theme="black" placement="left" title="Не показывать при печати">
        <Button
          data-mark="HideFromPrintControl"
          size="XS"
          theme="stroke_secondary"
          onClick={handleClick}
          beforeIcon={<IconFunctionalHide16 />}
        />
      </TooltipDesktop>
    </ControlWrapper>
  );
};
